import { useKeycloak } from "@react-keycloak/web";
import KeycloakLoading from "src/components/KeycloakLoading/KeycloakLoading";
import Page from "src/components/Page/Page";
import DiscourseSSO from "./DiscourseSSO";

const Discuss = () => {
  const { initialized } = useKeycloak();

  if (!initialized) {
    return (
      <KeycloakLoading />
    );
  }

  return (
    <Page>
      <DiscourseSSO />
    </Page>
  );
};

export default Discuss;
